import { Pipe, PipeTransform } from '@angular/core';
import { FormFieldDto } from '@core/api';

@Pipe({
  name: 'selectOptions',
  pure: true,
})
export class SelectOptionsPipe implements PipeTransform {
  transform(
    field: FormFieldDto,
    lang: string,
    fallback = '',
    relatedFieldValue?: string,
  ): { value: string; label: string }[] {
    if (!field) {
      return [];
    }

    if (Array.isArray(field.options) && field.options.length) {
      return field.options
        .filter(opt => !opt.additionalData?.['hide'])
        .map(opt => ({
          value: opt.title,
          label: opt.displayNames ? (opt.displayNames[lang] ?? fallback) : String(opt.title),
        }));
    }

    if (Array.isArray(field.choices)) {
      return field.choices.map((choice: string) => ({
        value: choice,
        label: choice,
      }));
    }

    return [];
  }
}
